<template>
  <div class="Menu _open">
    <div class="Menu__inner">
      <div class="Menu__header">
        <a class="Header_menu__logo Header_menu__logo--menu" href="" @click="window.location.reload()">
          <img
            alt=""
            class="Header_menu__logo_img "
            src="assets/img/melon_logo_blue.png"
          >
        </a>
      </div>
      <div class="Menu__area">
        <div v-if="isLogin" class="Menu__top">
          <a
            v-for="(notification,key) of notifications"
            :key="key"
            class="Menu__notice Info__link Info__link_notice"
            @click="readNoti(notification.info)"
          >
            {{ notification.info.title }}
          </a>
        </div>
        <div class="Menu__link_area">
          <div v-for="(blockOther,keyBlock) of otherMenus" :key="keyBlock" class="Menu__link_box">
            <template
              v-for="(menu,keyMenu) of blockOther"
            >
              <a
                v-if="menu.internal"
                :key="keyMenu"
                class="Menu__link"
                @click="openOtherLink(menu.path, menu.is_internal)"
              >
                {{ menu.title }}
              </a>
              <a v-else :key="keyMenu" :class="`Menu__link ${menu.menuOtherClass}`" @click="openOtherLink(menu.path, menu.is_internal)">{{ menu.title }}</a>
            </template>
          </div>
        </div>
      </div>

      <div class="Menu__footer Footer__menu">
        <div class="Menu__footer__inner">
          <div class="Footer__sns_area">
            <a
              class="Footer__sns_link Footer__sns_link--insta"
              href="https://www.instagram.com/melon_meditation/"
              target="_blank"
            />
            <a
              class="Footer__sns_link Footer__sns_link--fb"
              href="https://www.facebook.com/themeloncom/"
              target="_blank"
            />
            <a
              class="Footer__sns_link Footer__sns_link--twitter"
              href="https://twitter.com/MelonMeditation"
              target="_blank"
            />
            <a
              class="Footer__sns_link Footer__sns_link--line"
              href="https://page.line.me/676ljwcm?openQrModal=true"
              target="_blank"
            />
          </div>
          <div class="Footer__link_area">
            <a
              class="Footer__link _cl-03"
              href="https://www.the-melon.com/commercial-transactions/"
            >特定商取引法に基づく表記</a>
            <a class="Footer__link _cl-03" href="https://www.the-melon.com/privacy-policy/">プライバシーポリシー</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import notificationService from '@/services/notificationService'
import { mapState } from 'vuex'

export default {
  name: 'OtherMenuHeader',
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    otherMenus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  methods: {
    async readNoti(info) {
      this.$store.dispatch('layout/toggleMenuHeader')
      if (info.error_status !== 1 && info.error_status !== 2) {
        await notificationService.read(info.id)
      }
      window.location.href = info.link
    },
    openOtherLink(path, isInternal) {
      this.$store.dispatch('layout/toggleMenuHeader')
      if (isInternal) {
        window.location.href = path
      } else {
        window.open(path, '_blank')
      }
    }
  }
}
</script>
